// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sy-0";